module.exports = {
      id: "success-usage",
      viewBox: "0 0 82 82",
      url: __webpack_public_path__ + "svg-sprite-6b422ea7dc08f55780ae3689062e9e73.svg#success",
      toString: function () {
        return this.url;
      }
    }